module.exports = __webpack_public_path__ + "img/BigVLogoNewT.0c605621.png";